import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Container, Row, Col } from 'reactstrap';
import Booking from '@/components/Booking';

// Translation Higher Order Component
import { translate } from 'react-switch-lang';
const About = ({ t }) => {
	return (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className="cover"
				title={t('navbar.about')}
				description={`${t('about.text')} ${t('about.text2')}`}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_about')}`}
				canonical="/about"
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id="about-page" className="about-page" role="article">
					<Container>
						<article className="pb-5">
							<h1 className="page_text font-weight-bold">{t('navbar.about')}</h1>
							<h2 className="page_subtext text-uppercase">{t('topinfo.name')}</h2>
							<hr className="pregnancy-page_hr" />
							<p>{t('about.text')}</p>
							<p>{t('about.text1')}</p>
							<p>{t('about.text2')}</p>
							<p>{t('about.text3')}</p>
							<br />
							<Row>
								<Col md="6">
									<Col>
										<h2 className="page_subtext text-uppercase">{`${t('about.doctor')} David Assjodi`}</h2>
										<img
											width="520"
											height="347"
											className="img-fluid shadowed-img px-xs-5"
											src="/images/photo2.webp"
											alt="David Assjodi photo"
										/>
									</Col>
									<Col>
										<p className="pt-5">{t('about.david')}</p>
										<br />
									</Col>
								</Col>
								<Col md="6">
									<Col>
										<h2 className="page_subtext text-uppercase">{`${t('about.midwife')} Hafezeh Shakouri`}</h2>
										<img
											width="520"
											height="347"
											className="img-fluid shadowed-img px-xs-5"
											src="/images/photo5.webp"
											alt="Hafezeh Shakouri photo"
										/>
									</Col>
									<Col>
										<p className="pt-5">{t('about.hafezeh')}</p>
										<p>{t('about.hafezeh1')}</p>
										<br />
									</Col>
								</Col>
							</Row>
						</article>
						<Booking />
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default translate(About);
